/**
 * {@link WorkOrderCreationRequestsToolbar} model.
 */
export default class WorkOrderCreationRequestsToolbarModel {

    public from: Date | null = null;

    public to: Date | null = null;
    
    public search: string | null = null;
}